// Generat automat din README.md
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Calculator,
  Users,
  MessageCircle,
  TrendingUp,
  Megaphone,
  Shield,
  X,
  ChevronDown,
  Sparkles,
  Cloud,
  Database,
  Server,
  HardDrive,
  Upload,
  Download,
  Video,
  Calendar,
  Mail,
  Users2,
  Phone,
  MessageSquare
} from 'lucide-react';

const Sidebar = ({ isOpen, setIsOpen }) => {
  const location = useLocation();

  const menuItems = [
    {
      title: 'Enterprise',
      icon: Sparkles,
      path: '/enterprise',
      items: [
        { title: 'Prezentare Enterprise', path: '/enterprise' },
        { title: 'Dashboard Executiv', path: '/enterprise/dashboard' },
        { title: 'Raportare Avansată', path: '/enterprise/reporting' },
        { title: 'Automatizare Workflow-uri', path: '/enterprise/workflows' },
        { title: 'Conector Multi-BD', path: '/enterprise/database' }
      ]
    },
    {
      title: 'Contabilitate',
      icon: Calculator,
      path: '/accounting',
      items: [
        { title: 'Emitere Facturi', path: '/accounting/invoices' },
        { title: 'Urmărire Plăți', path: '/accounting/payments' },
        { title: 'Rapoarte Financiare', path: '/accounting/reports' },
        { title: 'Management Documente', path: '/accounting/documents' },
        { title: 'Migrare Date', path: '/accounting/migration' },
        { title: 'Verificare Discrepanțe', path: '/accounting/verification' },
        { title: 'SmartBill', path: 'https://www.smartbill.ro' },
        { title: 'Integrare Office 360', path: '/accounting/integration' }
      ]
    },
    {
      title: 'Resurse Umane',
      icon: Users,
      path: '/hr',
      items: [
        { title: 'Portal Angajați', path: '/hr/portal' },
        { title: 'Planificator Concedii', path: '/hr/vacations' },
        { title: 'Evaluare Performanță', path: '/hr/performance' },
        { title: 'Platformă E-learning', path: '/hr/elearning' },
        { title: 'Gestionare CV-uri', path: '/hr/cvs' },
        { title: 'Organigramă Digitală', path: '/hr/organigram' }
      ]
    },
    {
      title: 'CRM & AI',
      icon: MessageCircle,
      path: '/crm',
      items: [
        { title: 'Chatbot 24/7', path: '/crm/chatbot' },
        { title: 'Integrare WhatsApp', path: '/crm/whatsapp' },
        { title: 'Analiză Predictivă', path: '/crm/analytics' },
        { title: 'Automatizare RPA', path: '/crm/automation' },
        { title: 'CRM Complet', path: '/crm/complete' }
      ]
    },
    {
      title: 'Vânzări & Stocuri',
      icon: TrendingUp,
      path: '/sales',
      items: [
        { title: 'Previziune Vânzări', path: '/sales/forecast' },
        { title: 'Optimizare Stocuri', path: '/sales/inventory' },
        { title: 'Istoric Comenzi', path: '/sales/orders' },
        { title: 'Raportare Automată', path: '/sales/reporting' },
        { title: 'Integrare Logistică', path: '/sales/logistics' }
      ]
    },
    {
      title: 'Marketing AI',
      icon: Megaphone,
      path: '/marketing',
      items: [
        { title: 'Generare Conținut AI', path: '/marketing/content' },
        { title: 'Campanii Email', path: '/marketing/email' },
        { title: 'Analiză Performanță', path: '/marketing/analytics' },
        { title: 'Adaptare la Piață', path: '/marketing/adaptation' }
      ]
    },
    {
      title: 'Cloud Storage',
      icon: Cloud,
      path: '/cloud',
      items: [
        { title: 'Dashboard Cloud', path: '/cloud/dashboard' },
        { title: 'Fișiere & Documente', path: '/cloud/files' },
        { title: 'Upload Manager', path: '/cloud/upload' },
        { title: 'Backup & Sync', path: '/cloud/backup' },
        { title: 'Setări Amazon S3', path: '/cloud/settings' }
      ]
    },
    {
      title: 'Integrări Office',
      icon: Video,
      path: '/integrations',
      items: [
        { title: 'Microsoft 365', path: '/integrations/microsoft365' },
        { title: 'Teams & Calendar', path: '/integrations/teams' },
        { title: 'Zoom Meetings', path: '/integrations/zoom' },
        { title: 'SharePoint', path: '/integrations/sharepoint' },
        { title: 'Outlook Integration', path: '/integrations/outlook' }
      ]
    },
    {
      title: 'Securitate',
      icon: Shield,
      path: '/security',
      items: [
        { title: 'Monitorizare 24/7', path: '/security/monitoring' },
        { title: 'Detectare Amenințări', path: '/security/threats' },
        { title: 'Răspuns Automatizat', path: '/security/response' },
        { title: 'Raportare Incidente', path: '/security/incidents' }
      ]
    },
    // Website & Mobile module removed from sidebar
    // {
    //   title: 'Website & Mobile',
    //   icon: Globe,
    //   path: '/website',
    //   items: [
    //     { title: 'Website Responsive', path: '/website/responsive' },
    //     { title: 'Aplicații Native', path: '/website/native' },
    //     { title: 'Panou Administrativ', path: '/website/admin' },
    //     { title: 'Optimizare SEO', path: '/website/seo' }
    //   ]
    // }
  ];

  const [expandedItems, setExpandedItems] = React.useState({});

  const toggleExpanded = (index) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 z-20 bg-black/50 backdrop-blur-sm lg:hidden animate-in"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed left-0 top-0 z-30 w-72 h-screen bg-white/95 dark:bg-gray-900/95 backdrop-blur-xl shadow-strong transform transition-all duration-300 lg:relative lg:translate-x-0 border-r border-gray-200 dark:border-gray-700 flex flex-col ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        {/* Mobile header */}
        <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-200 dark:border-gray-700 lg:hidden flex-shrink-0">
          <div className="flex items-center">
            <Sparkles className="w-5 h-5 sm:w-6 sm:h-6 text-primary-600 mr-2" />
            <h2 className="text-base sm:text-lg font-semibold text-gray-900 dark:text-white">Meniu</h2>
          </div>
          <button
            onClick={() => setIsOpen(false)}
            className="p-1.5 sm:p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200"
          >
            <X className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
        </div>

        {/* Logo and brand */}
        <div className="p-4 sm:p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
          <div className="flex items-center">
            <div className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl mr-2 sm:mr-3">
              <Sparkles className="w-4 h-4 sm:w-6 sm:h-6 text-white" />
            </div>
            <div>
              <h1 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white">
                Botez de poveste
              </h1>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                Admin Dashboard
              </p>
            </div>
          </div>
        </div>

        {/* Navigation - Scrollable */}
        <div className="flex-1 overflow-y-auto custom-scrollbar">
          <div className="p-3 sm:p-4">
            <nav className="space-y-1 sm:space-y-2">
              {menuItems.map((item, index) => {
                const Icon = item.icon;
                const isExpanded = expandedItems[index];
                const isActive = location.pathname.startsWith(item.path);

                return (
                  <div key={index} className="animate-slide" style={{ animationDelay: `${index * 50}ms` }}>
                    <button
                      onClick={() => toggleExpanded(index)}
                      className={`sidebar-item w-full text-left ${isActive ? 'active' : ''}`}
                    >
                      <div className="flex items-center flex-1 min-w-0">
                        <Icon className="w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3 flex-shrink-0" />
                        <span className="font-medium text-sm sm:text-base truncate">{item.title}</span>
                      </div>
                      <ChevronDown
                        className={`w-3 h-3 sm:w-4 sm:h-4 transition-transform duration-300 flex-shrink-0 ${
                          isExpanded ? 'rotate-180' : ''
                        }`}
                      />
                    </button>

                    {isExpanded && (
                      <div className="mt-1 sm:mt-2 ml-6 sm:ml-8 space-y-1 animate-in">
                        {item.items.map((subItem, subIndex) => (
                          <Link
                            key={subIndex}
                            to={subItem.path}
                            onClick={() => setIsOpen(false)}
                            className={`block px-3 sm:px-4 py-2 sm:py-2.5 text-xs sm:text-sm rounded-xl transition-all duration-200 ${
                              location.pathname === subItem.path
                                ? 'bg-primary-50 dark:bg-primary-900/50 text-primary-700 dark:text-primary-300 font-medium shadow-soft'
                                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-800'
                            }`}
                          >
                            <span className="truncate block">{subItem.title}</span>
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Footer - Fixed at bottom */}
        <div className="flex-shrink-0 p-3 sm:p-4 border-t border-gray-200 dark:border-gray-700">
          <div className="p-3 sm:p-4 bg-gradient-to-r from-primary-50 to-blue-50 dark:from-primary-900/20 dark:to-blue-900/20 rounded-xl border border-primary-200 dark:border-primary-800">
            <div className="text-xs text-gray-600 dark:text-gray-400 text-center">
              <p className="font-medium mb-1">Botez de poveste</p>
              <p>v1.0</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
